import * as actionTypes from 'store/actions';
import store from 'store';
import { architeckCall } from 'database';
import { log } from 'database';

export const setArticles = async() => {
    return new Promise( async (resolve, reject) => {

        const articles = await architeckCall({
            method: 'get',
            url: '/api/v1/archk_articles/list?limit=500&loop=true'
        })

        if(articles.success) {

            store.dispatch({
                type: actionTypes.SET_APP_ARTICLES,
                payload: {
                    objects: articles.data
                }
            });


            resolve({success: true});
            return;

        } else {

            resolve({success: false, message: articles.message});
            
            log({
                url: window.location.href, 
                file: '/store/functions/articles.js', 
                code: 'REQUEST FAILURE', 
                text: articles.message.toString()
            });
        }

    })

}